import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPC_CHANNEL } from '../../_offline/electron.constants';
import { MarkSchema } from '../../_offline/models/mark.schema';
import { DatabaseBaseService } from '../base/database-base.service';
import { LoginUserOfflineService } from '../offline/login-user-offline.service';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class MarkDbService extends DatabaseBaseService {

  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService) {
    super(electronService, loginUserService);
  }

  getAll(): Observable<MarkSchema>  {
    return this.ipcSendSync(IPC_CHANNEL.MARK.GET_ALL, this.tenantId);
  }

  putAll(marks: MarkSchema): Observable<MarkSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.MARK.PUT_ALL, marks);
  }
}
